import React from 'react';
import _ from 'lodash';
import { convertToUtcDate } from 'library/time';
import { formatTags } from './tag.selectors';
// = =======================================
// TRAVEL SELECTORS
// = =======================================
export const getLegLabel = (item) => {
  if (item) {
    return (
      <div>
        <span>
          {item.reference_number}
        </span>
        {' '}
        [
        {item.departure_time.format('HH:mm')}
        {' '}
        -
        {item.arrival_time.format('HH:mm')}
        ]
      </div>
    );
  }
  return item;
};

export const getLegKeyLabel = (leg) => {
  if (leg && (leg.id || leg.key)) {
    const label = (leg.label ? leg.label : getLegLabel(leg));
    return {
      key: leg.id || leg.key,
      label
    };
  }
  return undefined;
};

export const getCarrier = (leg) => {
  if (!_.isEmpty(leg)) {
    return !_.isEmpty(leg.carrier)
      ? `${leg.carrier} (${leg.reference_number})`
      : leg.reference_number;
  }
  return 'NA';
};

export const getDepartureLocation = (leg) => {
  if (!_.isEmpty(leg)) {
    return leg.route ? `${leg.route.departure_location.name} (${leg.route.departure_location.code})` : 'NA';
  }
  return 'NA';
};

export const getArrivalLocation = (leg) => {
  if (!_.isEmpty(leg)) {
    return leg.route ? `${leg.route.arrival_location.name} (${leg.route.arrival_location.code})` : 'NA';
  }
  return 'NA';
};

export const getBookingSummary = (legs, dataSource) => {
  const { arrival_date, departure_date, leg } = dataSource;
  let item = null;
  if (leg) {
    item = leg && leg.id ? leg : legs.find(data => data.id === leg.key); // use data or update form input
  }
  return [
    {
      title: 'Carrier',
      description: getCarrier(item)
    },
    {
      title: 'Departing',
      description: `${getDepartureLocation(item)} on ${departure_date ? departure_date.format('DD/MM/YYYY HH:mm') : 'NA'}`
    },
    {
      title: 'Arriving',
      description: `${getArrivalLocation(item)} on ${arrival_date ? arrival_date.format('DD/MM/YYYY HH:mm') : 'NA'}`
    }
  ];
};

const getBookingStatus = (list = []) => {
  const status = (list.length > 0 ? list[0].status.name : 'N/A');
  let statusCount = 0;

  list.forEach((item) => {
    if (item.status.name.toLowerCase() === status.toLowerCase()) {
      statusCount++;
    }
  });

  return (statusCount === list.length ? status : 'Multiple');
};

export const formatTravelLeg = (item = {}) => ({
  ...item,
  departure_time: convertToUtcDate(item.departure_time, 'HH:mm'),
  arrival_time: convertToUtcDate(item.arrival_time, 'HH:mm')
});

export const formatTravelBooking = (item = {}) => ({
  ...item,
  departure_date: convertToUtcDate(item.departure_date),
  arrival_date: convertToUtcDate(item.arrival_date),
  leg: formatTravelLeg(item.leg),
  travel_mode: item.leg ? item.leg.route.travel_mode : undefined,
  route: item.leg ? item.leg.route : undefined,
  itemTags: item.itemTags && item.itemTags.length ? formatTags(item.itemTags) : []
});

export const formatTravelItinerary = (item = {}) => ({
  ...item,
  bookings: item.bookings ? item.bookings.map(booking => formatTravelBooking(booking)) : [],
  booking_status: getBookingStatus(item.bookings)
});

export const formatTravelLegList = (list = []) => list.map(item => formatTravelLeg(item));

export const formatTravelBookingList = (list = []) => list.map(item => formatTravelBooking(item));

export const formatTravelItineraryList = (list = []) => list.map(item => formatTravelItinerary(item));
